import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useIsChildBranch from "../../../hooks/useIsChildBranch";
import { isPosAllowed } from "../../../utils/companyCapabilities";

const AdministrationManagementSidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();
  const profileData = useSelector((state) => state.auth.profileData);
  const isChildBranch = useIsChildBranch();
  const posAllowed = isPosAllowed(profileData);

  return (
    <div
      className={`menu-item has-sub ${
        location.pathname.startsWith("/profile") ||
        location.pathname.startsWith("/pettyCash") ||
        location.pathname.startsWith("/branches") ||
        (!isChildBranch && location.pathname.startsWith("/administration/Billing"))
          ? "active"
          : ""
      }`}
    >
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-user-tie"></i>
        </div>
        <div className="menu-text">Administration</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${currentPath === "/profile" ? "active" : ""}`}
        >
          <NavLink to="/profile" className="menu-link">
            Profile
          </NavLink>
        </div>
        {/* Parent companies with POS only — hide for marketplace-only restaurants */}
        {posAllowed && (profileData?.parentComID === 0 || profileData?.ParentComID === 0) && (
          <div
            className={`menu-item ${
              currentPath.startsWith("/branches") ? "active" : ""
            }`}
          >
            <NavLink to="/branches" className="menu-link">
              <i className="fa-solid fa-code-branch me-2"></i>
              Branches
            </NavLink>
          </div>
        )}
        {/* <div
          className={`menu-item ${currentPath === "/setting" ? "active" : ""}`}
        >
          <NavLink to="/setting" className="menu-link">
            Setting
          </NavLink>
        </div> */}
        {/* <div
          className={`menu-item ${
            currentPath === "/managedevices" ? "active" : ""
          }`}
        >
          <NavLink to="/manageDevices" className="menu-link">
            Manage Devices
          </NavLink>
        </div> */}
        {/* <div
          className={`menu-item ${
            currentPath === "/printingreceipts" ? "active" : ""
          }`}
        >
          <NavLink to="/printingReceipts" className="menu-link">
            Printing Receipts
          </NavLink>
        </div> */}
        {/* <div
          className={`menu-item ${
            currentPath === "/paymentmethod" ? "active" : ""
          }`}
        >
          <NavLink to="/paymentMethod" className="menu-link">
            Payment Methods
          </NavLink>
        </div> */}
        {posAllowed && (
        <div
          className={`menu-item ${
            currentPath === "/pettycash/managepettycash" ? "active" : ""
          }`}
        >
          <NavLink to="/pettyCash/managePettyCash" className="menu-link">
            Petty Cash Heads
          </NavLink>
        </div>
        )}
        {!isChildBranch && (
          <div
            className={`menu-item ${
              currentPath === "/administration/billing" ? "active" : ""
            }`}
          >
            <NavLink to="/administration/Billing" className="menu-link">
              Billing
            </NavLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdministrationManagementSidebar;
